import React, { Fragment } from "react";
import Layout from "../customElements/components/layout.js";
import BannerSections from "../customElements/components/bannerSection";
import Schemes from "../customElements/components/schemes";
import { Container } from "../customElements/components/yuvaContainer";
import BannerImg from "../images/dyes/Dyes-Banner-Img.png";
import cashreward from  "../images/dyes/Reward_image.png";
import sportsscholorship from "../images/dyes/SportsScholarshipImg.png";
import sportsAcademy from "../images/dyes/dyes_cash_reward_img.png";
import Feereturn from "../images/dyes/FeeRembrace.png";
import SportsReservation from "../images/dyes/SportsReservation.png";
import KreedaRathnaAward from "../images/dyes/KreedaAward.png";
import LifetimeAward from "../images/dyes/LifeTimeAwardImg.png";
import Ekalavya from "../images/dyes/EkalavyaAward.png";

export default class Dyes extends React.Component {
   constructor() {
     super();
 
     this.state = {
       isKannada: true
     };
     this.toggleLang = this.toggleLang.bind(this);
   }
 
   toggleLang() {
     this.setState({ isKannada: !this.state.isKannada });
   }
   render()
   {
      return(
         <Layout title="Yuva | ಯುವ ಸಬಲೀಕರಣ ಮತ್ತು ಕ್ರೀಡಾ ಇಲಾಖೆ | DEPARTMENT OF YOUTH EMPOWERMENT AND SPORTS " isKannada={this.state.isKannada} toggleLang={this.toggleLang}>
         <BannerSections bgImg={BannerImg}
         title= {this.state.isKannada ? "ಯುವ ಸಬಲೀಕರಣ ಮತ್ತು ಕ್ರೀಡಾ ಇಲಾಖೆ" : "DEPARTMENT OF YOUTH EMPOWERMENT AND SPORTS"}>
         </BannerSections>
         <div className="section">
         <Container>
           <div>
         <Schemes
         programImage={cashreward}
         ProgramTitle ={this.state.isKannada ? "ನಗದು ಪುರಸ್ಕಾರ": "Cash Award"}
         Programdisc ={this.state.isKannada ? "ರಾಷ್ಟ್ರೀಯ ಕ್ರೀಡಾ ಒಕ್ಕೂಟದಿಂದ ಮಾನ್ಯತೆ ಪಡೆದ ರಾಷ್ಟ್ರ ಮಟ್ಟದ ಸ್ಪರ್ಧೆಯಲ್ಲಿ ಮತ್ತು ಮಾನ್ಯತೆ ಪಡೆದ ಅಂತರಾಷ್ಟ್ರೀಯ ಸ್ಪರ್ಧೆಯ ಒಲಿಂಪಿಕ್ ವಿಭಾಗದಲ್ಲಿ ಪದಕ ಪಡೆದ ಕ್ರೀಡಾಳುಗಳಿಗೆ ಸರಕಾರ ನೀಡುವ ನಗದು ಪುರಸ್ಕಾರ.":"Sports persons who have own the medals at National level competitions organised by recognized National Sports Federations in Olympic Sports Disciplines and won medals in recognized International Sports Competitions are given cash awards as per Government."}
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}
         link="/cashAward/">
           
         </Schemes>
         <Schemes
         programImage={sportsscholorship}
         ProgramTitle ={this.state.isKannada ? "ಕ್ರೀಡಾ ವಿದ್ಯಾರ್ಥಿ ವೇತನ" : "Sports Scholarship"}
         Programdisc ={ this.state.isKannada ? "ಕ್ರೀಡಾಳುಗಳಿಗೆ ರೂ. 10,000/- ವಿದ್ಯಾರ್ಥಿವೇತನ": "Rs. 10000/- annual Scholarship to sports persons."}
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}
         link="/sports-scholarship/">
         </Schemes>
         {/* <Schemes
         programImage={cashreward1}
         ProgramTitle ="Cash Award"
         Programdisc ="Sports persons who have own the medals at National level competitions organised by recognized 
         National Sports Federations in Olympic Sports Disciplines and won medals in recognized International 
         Sports Competitions are given cash awards as per Government."
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}>
         </Schemes> */}
         <Schemes
         programImage={Feereturn}
         ProgramTitle ={this.state.isKannada ? "ಶುಲ್ಕ ಮರು-ವಿತರಣೆ": "Fee Re-imbursement"}
         Programdisc ={this.state.isKannada ? "ರಾಷ್ಟ್ರೀಯ ಕ್ರೀಡಾ ಒಕ್ಕೂಟದಿಂದ ಮಾನ್ಯತೆ ಪಡೆದಿರುವ ರಾಷ್ಟ್ರೀಯ ಮತ್ತು ಅಂತರಾಷ್ಟ್ರೀಯ ಸ್ಪರ್ಧೆಯಲ್ಲಿ ಭಾಗವಹಿಸಿ ಅತ್ಯುತ್ತಮ ಪ್ರದರ್ಶನ ನೀಡಿರುವ ಮತ್ತು ಅಂತರಾಷ್ಟ್ರೀಯ ಕ್ರೀಡಾ ಒಕ್ಕೂಟದಿಂದ ಮಾನ್ಯತೆ ಪಡೆದ ಒಲಿಂಪಿಕ್ ಕ್ರೀಡಾ ವಿಭಾಗದಲ್ಲಿ ಭಾಗವಹಿಸಿ ಪದಕ ಪಡೆದ ಕ್ರೀಡಾಳುಗಳಿಗೆ ಸರಕಾರ ನೀಡುವ ನಗದು ಪುರಸ್ಕಾರ." :"Sports persons who have achieved outstanding performance in National and International events  organised by recognized National Sports Federations in Olympic Sports Disciplines and won medals in recognized International Sports Competitions are given cash awards as per Government"}
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}
         link ="/fee-reimbursment/">
         </Schemes>
         <Schemes
         programImage={SportsReservation}
         ProgramTitle ={this.state.isKannada ? "ವೃತ್ತಿಪರ ಕೋರ್ಸುಗಳಲ್ಲಿ ಕ್ರೀಡಾ ಕೋಟದಡಿಯಲ್ಲಿ ಮೀಸಲಾತಿ":"Reservation for Sports quota in Professional Courses: (CET):"}
         Programdisc ={this.state.isKannada ? "ಕ್ರೀಡೆಯಿಂದಾಗಿ ವಿದ್ಯಾಭ್ಯಾಸವನ್ನು ಮೊಟಕುಗೊಳಿಸಿದ್ದಲ್ಲಿ ಅಥವಾ ಅದೇ ತರಗತಿಯಲ್ಲಿ ಮುಂದುವರಿಸಿದರೂ, 8 ರಿಂದ 12ನೇ ತರಗತಿಯಲ್ಲಿನ  ಪ್ರತಿಭಾನ್ವಿತ ಕ್ರೀಡಾ ಪಟುಗಳ ಸಾಧನೆಗಳನ್ನು ಪರಿಗಣ ಸಲು 5 ವರ್ಷಗಳ ವಿದ್ಯಾಭ್ಯಾಸದ ಅವಧಿಯನ್ನು ಪರಿಷ್ಕರಿಸಲಾಗಿದೆ. ಮಾನ್ಯತೆ ಪಡೆದ ರಾಷ್ಟ್ರೀಯ ಕ್ರೀಡಾ ಒಕ್ಕೂಟ ಆಯೋಜಿಸಿರುವ ರಾಷ್ಟ್ರ ಮಟ್ಟದ ಸ್ಪರ್ಧೆಯಲ್ಲಿ ಮತ್ತು ಅಂತರಾಷ್ಟ್ರೀಯ ಸ್ಪರ್ಧೆತ ಒಲಿಂಪಿಕ್ ಕ್ರೀಡೆಯಲ್ಲಿ ಪದಕ ಪಡೆದ ಕ್ರೀಡಾಳುಗಳಿಗೆ ಸರಕಾರ ನೀಡುವ ನಗದು ಪುರಸ್ಕಾರ.":"Five year period of study is revised to consider the achievements of talented sports persons during 8th to 12th standards, even if they have taken a break or repeated the same standard, because of sports. Sports persons who have achieved outstanding performance in National and International events  organised by recognized National Sports Federations in Olympic Sports Disciplines and won medals in recognized International Sports Competitions are given cash awards as per Government"}
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}
         link ="/reservation-for-sports-quota-in-professional-courses/">
         </Schemes>
         <Schemes
         programImage={KreedaRathnaAward}
         ProgramTitle ={this.state.isKannada ? "ಕರ್ನಾಟಕ ಕ್ರೀಡಾರತ್ನ ಪ್ರಶಸ್ತಿ" : "Karnataka Kreeda Rathna Award"}
         Programdisc ={this.state.isKannada ?  "ಕರ್ನಾಟಕ ಕ್ರೀಡಾರತ್ನ ಪ್ರಶಸ್ತಿಯನ್ನು ಗ್ರಾಮೀಣ ಮತ್ತು ಸಾಂಪ್ರದಾಯಕ ಕ್ರೀಡೆಗಳಲ್ಲಿ ಉತ್ಕೃಷ್ಟತೆಯನ್ನು ಸಾಧಿಸಿದ ರಾಜ್ಯದಿಂದ ಪ್ರಮುಖ ಕ್ರೀಡಾಪಟುಗಳಿಗೆ ನೀಡಲಾಗುವುದು. ಪ್ರತಿಯೊಬ್ಬರಿಗೂ ಕಂಚಿನ ಸ್ಮರಣ ಕೆ, ಪುರುಷ ಮತ್ತು ಮಹಿಳೆಯರಿಗೆ ಸಮವಸ್ತ್ರ ಹಾಗೂ ರೂ. 1 ಲಕ್ಷ ನಗದು ಪುರಸ್ಕಾರ." :"Karnataka Kreeda Rathna  Awards are awarded to eminent sports persons from the State who had achieved excellence in rural and traditional sports. The award includes, bronze memento, uniforms for Men and Women and sum of Rs.1,00,000/- Cash each."}
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}
         link ="/karnataka-kreeda-rathna-award/">
         </Schemes>
         <Schemes
         programImage={LifetimeAward}
         ProgramTitle ={this.state.isKannada ? "ಜೀವಮಾನ ಸಾಧನೆಗಾಗಿ ನೀಡುವ ಪುರಸ್ಕಾರ":"Life Time Achievement Award:"}
         Programdisc ={this.state.isKannada ? "ಕ್ರೀಡಾ ಕ್ಷೇತ್ರಕ್ಕೆ ಅಪ್ರತಿಮ ಕೊಡುಗೆಯನ್ನು ನೀಡಿರುವ ಕ್ರೀಡಾ ತರಬೇತುದಾರರಿಗೆ ಜೀವಮಾನ ಸಾಧನೆಗಾಗಿ ನೀಡುವ ಪುರಸ್ಕಾರ. ಈ ಪುರಸ್ಕಾರವು ಕಂಚಿನ ಸ್ಮರಣ ಕೆ, ಸಮವಸ್ತ್ರ ಮತ್ತು ರೂ. 1.50 ಲಕ್ಷ ನಗದನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ.": "Life Time Achievement Award is awarded to coaches for their outstanding contribution to the development of sports. The award includes bronze memento, uniforms and Rs.1.5 lakh Cash each."}
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}
         link ="/life-time-achievement-award/">
         </Schemes>
         <Schemes
         programImage={sportsAcademy}
         ProgramTitle ={this.state.isKannada ? "ಕ್ರೀಡಾ ಕ್ಷೇತ್ರದ ಅತ್ಯುತ್ತಮ ಸಾಧನಾ ಪ್ರಶಸ್ತಿ":"Sports Academy of Excellence:"}
         Programdisc ={this.state.isKannada ? "ಅಂತರಾಷ್ಟ್ರೀಯ ಮಟ್ಟದ ಕ್ರೀಡಾ ಸ್ಪರ್ಧೆಯಲ್ಲಿ ಪದಕ ಪಡೆದ ಸಂಭಾವ್ಯ ವಿಜೇತರಿಗೆ ತರಬೇತಿಗಾಗಿ, ಪ್ರಯಾಣ ಮತ್ತು ಮಿತಆಹಾರ ಕ್ರಮಕ್ಕಾಗಿ ನೀಡುವ ಹಣಕಾಸಿನ ಸಹಕಾರ.": "Potential medal winners at International level competitions are provided with financial support to cover expenses towards coaching, travel, kit and diet."}
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}
         link ="/sports-academy-of-excellence/">
         </Schemes>
         <Schemes
         programImage={Ekalavya}
         ProgramTitle ={this.state.isKannada ? "ಏಕಲವ್ಯ ಪ್ರಶಸ್ತಿತಿ":"Ekalavya Awards"}
         Programdisc ={this.state.isKannada ? "ಏಕಲವ್ಯ ಪ್ರಶಸ್ತಿಯನ್ನು ಈ ಹಿಂದಿನ 5 ವರ್ಷಗಳಲ್ಲಿ ಉತ್ತಮ ಕ್ರೀಡಾ ಸಾಧನೆಗೈದ ಉತ್ಖೃಷ್ಟ ಕ್ರೀಡಾಪಟುಗಳಿಗೆ ನೀಡಲಾಗುವುದು. ಪ್ರಶಸ್ತಿಯು ಏಕಲವ್ಯನ  ಕಂಚಿನ ಪ್ರತಿಮೆ, ಪುರುಷ / ಮಹಿಳಿಯರಿಗೆ ಸಮವಸ್ತ್ರ ಹಾಗೂ ರೂ. 2.00 ಲಕ್ಷದ ನಗದನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ.": "Ekalavya Awards are awarded to eminent sports persons from the State for their achievements in the previous 5 years.  The award includes, bronze statue of Ekalavya, uniforms for Men and Women and Rs.2,00,000/- Cash each."}
         btntext = {this.state.isKannada ?"ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ" :"Know more"}
         link="/ekalavya-awards/">
         </Schemes>
         </div>
         </Container>
         </div>
         </Layout>
      )
   }
}